var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "search-items" },
      [
        _c(
          "el-radio-group",
          {
            attrs: { size: "small" },
            model: {
              value: _vm.timeRange,
              callback: function ($$v) {
                _vm.timeRange = $$v
              },
              expression: "timeRange",
            },
          },
          [
            _c("el-radio-button", { attrs: { label: "day" } }, [_vm._v("日")]),
            _c("el-radio-button", { attrs: { label: "week" } }, [_vm._v("周")]),
            _c("el-radio-button", { attrs: { label: "month" } }, [
              _vm._v("月"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content scrollable" },
      [
        _c(
          "el-row",
          { staticClass: "combined-section" },
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c("div", { staticClass: "section-header" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v("运营数据"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "table-card unified-table" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.filteredData,
                        height: "550",
                        size: "small",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.timeLabel,
                          width: "120",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " + _vm._s(_vm.formatDate(scope.row)) + " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "check_count",
                          label: "检测人数",
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "unpaid_count",
                          label: "检测未付款人数",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "paid_count",
                          label: "检测已付款人数",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "total_order_amount",
                          label: "销售额",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#409EFF",
                                      "font-weight": "500",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          _vm.formatMoney(
                                            scope.row.total_order_amount
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "total_group_amount",
                          label: "收益流水",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#409EFF",
                                      "font-weight": "500",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          _vm.formatMoney(
                                            scope.row.total_group_amount
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }